import httpClient from "api/httpClient";

const getArbitrationsStats = (params?: Record<string, any>) =>
  httpClient.get(`admin/arbitrations/stats`, { params });

export default { getArbitrationsStats };
